import React from "react";
import { motion as m } from "framer-motion";
import { Helmet } from "react-helmet";
import { IoBookSharp } from "react-icons/io5";
import { FaHatCowboy } from "react-icons/fa";
import { VscBook } from "react-icons/vsc";
import Card from 'react-bootstrap/Card';

const Emergingtechnologies = () => {
    return (
        <m.div
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            exit={{ scaleY: 0 }}
            transition={{ duration: 0.5 }}
        >
            <>
                <Helmet>
                    <title>Department of Engineering and Emerging Technologies |</title>
                </Helmet>
                {/* <Navcomponent /> */}
                <section id="courses" className="border-green">
                    <div className="course-mainheading">
                        <h1 className="font-tomatosemibold text-orange text-center"><IoBookSharp /> PROGRAM</h1>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <div className="row justify-center">
                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            <div className="courseimg-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/bseconomics.jpg'} alt="course" />
                                            </div>
                                            <div className="course-pill">
                                                <FaHatCowboy />  Engineering and Emerging Technologies
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">BS Engineering and Emerging Technologies</Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                                The University offers a BS in Engineering and Emerging Technologies, focusing on cutting-edge advancements and interdisciplinary approaches. Students explore areas such as robotics, artificial intelligence, and sustainable engineering. The program prepares graduates for innovative careers in technology and engineering fields. Hands-on projects and industry partnerships enhance practical skills and career readiness.
                                            </Card.Text>
                                            <div className="book float-right">
                                                <VscBook />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* <Footer /> */}
            </>
        </m.div>
    )


}

export default Emergingtechnologies